import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "clearfix"
};
const _hoisted_2 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_3 = { class: "checkbox-wrapper" };
const _hoisted_4 = { class: "clearfix" };
const _hoisted_5 = { class: "col-xs-12 col-sm-6 col-md-6 bottom10" };
const _hoisted_6 = { class: "invalid-feedback" };
const _hoisted_7 = { class: "col-xs-12 col-sm-6 col-md-6 bottom10" };
const _hoisted_8 = { class: "invalid-feedback" };
const _hoisted_9 = {
    key: 0,
    class: "col-xs-12 col-sm-6 col-md-6 bottom10"
};
const _hoisted_10 = { class: "invalid-feedback" };
const _hoisted_11 = {
    key: 1,
    class: "clearfix"
};
const _hoisted_12 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_13 = { class: "checkbox-wrapper bottom10" };
const _hoisted_14 = { class: "ms-3" };
const _hoisted_15 = { class: "bottom10" };
const _hoisted_16 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_17 = { class: "checkbox-wrapper bottom10" };
const _hoisted_18 = { class: "ms-3" };
const _hoisted_19 = { class: "bottom10" };
const _hoisted_20 = { class: "clearfix" };
const _hoisted_21 = { class: "col-xs-12 col-sm-6 col-md-6 bottom10" };
const _hoisted_22 = { class: "form-text text-muted" };
const _hoisted_23 = {
    key: 0,
    class: "top10"
};
const _hoisted_24 = {
    key: 2,
    class: "clearfix"
};
const _hoisted_25 = { class: "col-xs-12 col-sm-6 col-md-6" };
const _hoisted_26 = { class: "checkbox-wrapper bottom10" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_alert = _resolveComponent("b-alert");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        (_ctx.isClientAdministrator)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_b_form_checkbox, {
                            modelValue: _ctx.alarmsSettingsModel.requireCommentOnAcknowledge,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.alarmsSettingsModel.requireCommentOnAcknowledge) = $event)),
                            size: "lg"
                        }, {
                            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                    _createTextVNode("\r\n\t\t\t\t\tRequire comment when acknowledging an alarm\r\n\t\t\t\t", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                    ])
                ])
            ]))
            : _createCommentVNode("v-if", true),
        _cache[65] || (_cache[65] = _createTextVNode()),
        _createElementVNode("div", _hoisted_4, [
            _cache[22] || (_cache[22] = _createElementVNode("h3", { class: "mt-0 mb-4" }, "Battery Life Prediction Settings", -1 /* CACHED */)),
            _cache[23] || (_cache[23] = _createTextVNode()),
            _createElementVNode("div", _hoisted_5, [
                _cache[13] || (_cache[13] = _createElementVNode("label", null, "\r\n\t\t\t\tOhmic Rise Limit For Block Replacement (%)\r\n\t\t\t", -1 /* CACHED */)),
                _cache[14] || (_cache[14] = _createTextVNode()),
                _createVNode(_component_b_form_input, _mergeProps(_ctx.ohmicRiseLimitForBlockReplacementVal, {
                    type: "number",
                    modelValue: _ctx.batteryLifePredictionSettingsModel.ohmicRiseLimitForBlockReplacement,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.batteryLifePredictionSettingsModel.ohmicRiseLimitForBlockReplacement) = $event)),
                    modelModifiers: { trim: true },
                    class: { 'is-invalid': _ctx.errors && _ctx.errors.ohmicRiseLimitForBlockReplacement },
                    min: "1",
                    max: "100"
                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                _cache[15] || (_cache[15] = _createTextVNode()),
                _withDirectives(_createElementVNode("div", _hoisted_6, "\r\n\t\t\t\t* Please enter a valid value between 1 and 100\r\n\t\t\t", 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.errors && _ctx.errors.ohmicRiseLimitForBlockReplacement]
                ])
            ]),
            _cache[24] || (_cache[24] = _createTextVNode()),
            _createElementVNode("div", _hoisted_7, [
                _cache[16] || (_cache[16] = _createElementVNode("label", null, "\r\n\t\t\t\t% Of Blocks Above Ohmic Rise (%) Limit For String Replacement\r\n\t\t\t", -1 /* CACHED */)),
                _cache[17] || (_cache[17] = _createTextVNode()),
                _createVNode(_component_b_form_input, _mergeProps(_ctx.percOfBlocksAboveOhmicRiseLimitForStringReplacementVal, {
                    type: "number",
                    modelValue: _ctx.batteryLifePredictionSettingsModel.percOfBlocksAboveOhmicRiseLimitForStringReplacement,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.batteryLifePredictionSettingsModel.percOfBlocksAboveOhmicRiseLimitForStringReplacement) = $event)),
                    modelModifiers: { trim: true },
                    class: { 'is-invalid': _ctx.errors && _ctx.errors.percOfBlocksAboveOhmicRiseLimitForStringReplacement },
                    min: "1",
                    max: "100"
                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                _cache[18] || (_cache[18] = _createTextVNode()),
                _withDirectives(_createElementVNode("div", _hoisted_8, "\r\n\t\t\t\t* Please enter a valid value between 1 and 100\r\n\t\t\t", 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.errors && _ctx.errors.percOfBlocksAboveOhmicRiseLimitForStringReplacement]
                ])
            ]),
            _cache[25] || (_cache[25] = _createTextVNode()),
            (_ctx.isPowerShield)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _cache[19] || (_cache[19] = _createElementVNode("label", null, "\r\n\t\t\t\tMinimum Ohmic Rise % To Use Prediction\r\n\t\t\t", -1 /* CACHED */)),
                    _cache[20] || (_cache[20] = _createTextVNode()),
                    _createVNode(_component_b_form_input, _mergeProps(_ctx.minOhmicRiseToUsePredictionVal, {
                        type: "number",
                        modelValue: _ctx.batteryLifePredictionSettingsModel.minOhmicRiseToUsePrediction,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.batteryLifePredictionSettingsModel.minOhmicRiseToUsePrediction) = $event)),
                        modelModifiers: { trim: true },
                        class: { 'is-invalid': _ctx.errors && _ctx.errors.minOhmicRiseToUsePrediction },
                        min: "1",
                        max: "100"
                    }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                    _cache[21] || (_cache[21] = _createTextVNode()),
                    _withDirectives(_createElementVNode("div", _hoisted_10, "\r\n\t\t\t\t* Please enter a valid value between 1 and 100\r\n\t\t\t", 512 /* NEED_PATCH */), [
                        [_vShow, _ctx.errors && _ctx.errors.minOhmicRiseToUsePrediction]
                    ])
                ]))
                : _createCommentVNode("v-if", true)
        ]),
        _cache[66] || (_cache[66] = _createTextVNode()),
        (_ctx.isAdministrator)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _cache[52] || (_cache[52] = _createElementVNode("h3", { class: "mt-0 mb-4" }, "Issues", -1 /* CACHED */)),
                _cache[53] || (_cache[53] = _createTextVNode()),
                _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_b_form_checkbox, {
                            modelValue: _ctx.issueSettingsModel.createIssueForOhmicCriticalAlarm,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.issueSettingsModel.createIssueForOhmicCriticalAlarm) = $event)),
                            size: "lg"
                        }, {
                            default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                                    _createTextVNode("\r\n\t\t\t\t\tCreate an Issue When Ohmic Critical Alarm is Raised\r\n\t\t\t\t", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                    ]),
                    _cache[38] || (_cache[38] = _createTextVNode()),
                    _withDirectives(_createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                            _cache[27] || (_cache[27] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\tIssue Description for Ohmic Critical Alarm\r\n\t\t\t\t\t", -1 /* CACHED */)),
                            _cache[28] || (_cache[28] = _createTextVNode()),
                            _createVNode(_component_b_form_input, _mergeProps(_ctx.ohmicCriticalAlarmDescriptionVal, {
                                modelValue: _ctx.issueSettingsModel.ohmicCriticalAlarmDescription,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.issueSettingsModel.ohmicCriticalAlarmDescription) = $event)),
                                modelModifiers: { trim: true },
                                maxlength: 250,
                                class: { 'is-invalid': _ctx.errors && _ctx.errors.ohmicCriticalAlarmDescription }
                            }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                            _cache[29] || (_cache[29] = _createTextVNode()),
                            _cache[30] || (_cache[30] = _createElementVNode("small", { class: "form-text text-muted" }, "\r\n\t\t\t\t\t\tDefault wording is used if not set.\r\n\t\t\t\t\t", -1 /* CACHED */)),
                            _cache[31] || (_cache[31] = _createTextVNode()),
                            _withDirectives(_createElementVNode("div", { class: "invalid-feedback" }, _toDisplayString(_ctx.errors.ohmicCriticalAlarmDescription), 513 /* TEXT, NEED_PATCH */), [
                                [_vShow, _ctx.errors && _ctx.errors.ohmicCriticalAlarmDescription]
                            ])
                        ]),
                        _cache[37] || (_cache[37] = _createTextVNode()),
                        _createElementVNode("div", null, [
                            _cache[32] || (_cache[32] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\tTask Description for Ohmic Critical Alarm\r\n\t\t\t\t\t", -1 /* CACHED */)),
                            _cache[33] || (_cache[33] = _createTextVNode()),
                            _createVNode(_component_b_form_input, _mergeProps(_ctx.ohmicCriticalAlarmTaskVal, {
                                modelValue: _ctx.issueSettingsModel.ohmicCriticalAlarmTask,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.issueSettingsModel.ohmicCriticalAlarmTask) = $event)),
                                modelModifiers: { trim: true },
                                maxlength: 250,
                                class: { 'is-invalid': _ctx.errors && _ctx.errors.ohmicCriticalAlarmTask }
                            }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                            _cache[34] || (_cache[34] = _createTextVNode()),
                            _cache[35] || (_cache[35] = _createElementVNode("small", { class: "form-text text-muted" }, "\r\n\t\t\t\t\t\tDefault wording is used if not set.\r\n\t\t\t\t\t", -1 /* CACHED */)),
                            _cache[36] || (_cache[36] = _createTextVNode()),
                            _withDirectives(_createElementVNode("div", { class: "invalid-feedback" }, _toDisplayString(_ctx.errors.ohmicCriticalAlarmTask), 513 /* TEXT, NEED_PATCH */), [
                                [_vShow, _ctx.errors && _ctx.errors.ohmicCriticalAlarmTask]
                            ])
                        ])
                    ], 512 /* NEED_PATCH */), [
                        [_vShow, _ctx.issueSettingsModel.createIssueForOhmicCriticalAlarm]
                    ])
                ]),
                _cache[54] || (_cache[54] = _createTextVNode()),
                _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_b_form_checkbox, {
                            modelValue: _ctx.issueSettingsModel.createIssueForAmbTempCriticalAlarm,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.issueSettingsModel.createIssueForAmbTempCriticalAlarm) = $event)),
                            size: "lg"
                        }, {
                            default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                                    _createTextVNode("\r\n\t\t\t\t\tCreate an Issue When Amb. Temperature Critical Alarm is Raised\r\n\t\t\t\t", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                    ]),
                    _cache[51] || (_cache[51] = _createTextVNode()),
                    _withDirectives(_createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                            _cache[40] || (_cache[40] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\tIssue Description for Amb. Temperature Critical Alarm\r\n\t\t\t\t\t", -1 /* CACHED */)),
                            _cache[41] || (_cache[41] = _createTextVNode()),
                            _createVNode(_component_b_form_input, _mergeProps(_ctx.ambTempCriticalAlarmDescriptionVal, {
                                modelValue: _ctx.issueSettingsModel.ambTempCriticalAlarmDescription,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.issueSettingsModel.ambTempCriticalAlarmDescription) = $event)),
                                modelModifiers: { trim: true },
                                maxlength: 250,
                                class: { 'is-invalid': _ctx.errors && _ctx.errors.ambTempCriticalAlarmDescription }
                            }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                            _cache[42] || (_cache[42] = _createTextVNode()),
                            _cache[43] || (_cache[43] = _createElementVNode("small", { class: "form-text text-muted" }, "\r\n\t\t\t\t\t\tDefault wording is used if not set.\r\n\t\t\t\t\t", -1 /* CACHED */)),
                            _cache[44] || (_cache[44] = _createTextVNode()),
                            _withDirectives(_createElementVNode("div", { class: "invalid-feedback" }, _toDisplayString(_ctx.errors.AmbTempCriticalAlarmDescription), 513 /* TEXT, NEED_PATCH */), [
                                [_vShow, _ctx.errors && _ctx.errors.ambTempCriticalAlarmDescription]
                            ])
                        ]),
                        _cache[50] || (_cache[50] = _createTextVNode()),
                        _createElementVNode("div", null, [
                            _cache[45] || (_cache[45] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\tTask Description for Amb. Temperature Critical Alarm\r\n\t\t\t\t\t", -1 /* CACHED */)),
                            _cache[46] || (_cache[46] = _createTextVNode()),
                            _createVNode(_component_b_form_input, _mergeProps(_ctx.ambTempCriticalAlarmTaskVal, {
                                modelValue: _ctx.issueSettingsModel.ambTempCriticalAlarmTask,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.issueSettingsModel.ambTempCriticalAlarmTask) = $event)),
                                modelModifiers: { trim: true },
                                maxlength: 250,
                                class: { 'is-invalid': _ctx.errors && _ctx.errors.ambTempCriticalAlarmTask }
                            }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                            _cache[47] || (_cache[47] = _createTextVNode()),
                            _cache[48] || (_cache[48] = _createElementVNode("small", { class: "form-text text-muted" }, "\r\n\t\t\t\t\t\tDefault wording is used if not set.\r\n\t\t\t\t\t", -1 /* CACHED */)),
                            _cache[49] || (_cache[49] = _createTextVNode()),
                            _withDirectives(_createElementVNode("div", { class: "invalid-feedback" }, _toDisplayString(_ctx.errors.AmbTempCriticalAlarmTask), 513 /* TEXT, NEED_PATCH */), [
                                [_vShow, _ctx.errors && _ctx.errors.ambTempCriticalAlarmTask]
                            ])
                        ])
                    ], 512 /* NEED_PATCH */), [
                        [_vShow, _ctx.issueSettingsModel.createIssueForAmbTempCriticalAlarm]
                    ])
                ])
            ]))
            : _createCommentVNode("v-if", true),
        _cache[67] || (_cache[67] = _createTextVNode()),
        _createElementVNode("div", _hoisted_20, [
            _cache[60] || (_cache[60] = _createElementVNode("h3", { class: "mt-0 mb-4" }, "Audit Log", -1 /* CACHED */)),
            _cache[61] || (_cache[61] = _createTextVNode()),
            _createElementVNode("div", _hoisted_21, [
                _cache[56] || (_cache[56] = _createElementVNode("label", null, "\r\n\t\t\t\tKeep Audit Log entries for (days)\r\n\t\t\t", -1 /* CACHED */)),
                _cache[57] || (_cache[57] = _createTextVNode()),
                _createVNode(_component_b_form_input, {
                    type: "number",
                    modelValue: _ctx.auditRetentionDays,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.auditRetentionDays) = $event)),
                    modelModifiers: { number: true },
                    min: _ctx.activityAuditSettingsModel.minimumDaysToRetain,
                    max: _ctx.activityAuditSettingsModel.maximumDaysToRetain,
                    placeholder: _ctx.auditRetentionPlaceholder
                }, null, 8 /* PROPS */, ["modelValue", "min", "max", "placeholder"]),
                _cache[58] || (_cache[58] = _createTextVNode()),
                _createElementVNode("small", _hoisted_22, "\r\n\t\t\t\tLeave blank to use the default of\r\n\t\t\t\t" + _toDisplayString(_ctx.activityAuditSettingsModel.inheritedDaysToRetain) + " days.\r\n\t\t\t\tMust be between " + _toDisplayString(_ctx.activityAuditSettingsModel.minimumDaysToRetain) + " and\r\n\t\t\t\t" + _toDisplayString(_ctx.activityAuditSettingsModel.maximumDaysToRetain) + " days.\r\n\t\t\t", 1 /* TEXT */),
                _cache[59] || (_cache[59] = _createTextVNode()),
                (_ctx.auditRetentionImpact && _ctx.auditRetentionImpact.isReduction)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createVNode(_component_b_alert, {
                            variant: "warning",
                            "model-value": true
                        }, {
                            default: _withCtx(() => [
                                _cache[55] || (_cache[55] = _createElementVNode("strong", null, "This shortens retention.", -1 /* CACHED */)),
                                _createTextVNode(" " + _toDisplayString(_ctx.auditRetentionImpact.entriesAffected.toLocaleString()) + " existing\r\n\t\t\t\t\t" + _toDisplayString(_ctx.auditRetentionImpact.entriesAffected === 1 ? 'entry' : 'entries') + "\r\n\t\t\t\t\twill become eligible for deletion the next time the retention job runs.\r\n\t\t\t\t\tThis cannot be undone once it has run.\r\n\t\t\t\t", 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]))
                    : _createCommentVNode("v-if", true)
            ])
        ]),
        _cache[68] || (_cache[68] = _createTextVNode()),
        (_ctx.isAdministrator)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _cache[63] || (_cache[63] = _createElementVNode("h3", { class: "mt-0 mb-4" }, "Services", -1 /* CACHED */)),
                _cache[64] || (_cache[64] = _createTextVNode()),
                _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_b_form_checkbox, {
                            modelValue: _ctx.companyServicesSettingsModel.isAssurePlusCustomer,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.companyServicesSettingsModel.isAssurePlusCustomer) = $event)),
                            size: "lg"
                        }, {
                            default: _withCtx(() => [...(_cache[62] || (_cache[62] = [
                                    _createTextVNode("\r\n\t\t\t\t\tIs AssurePlus customer\r\n\t\t\t\t", -1 /* CACHED */)
                                ]))]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                    ])
                ])
            ]))
            : _createCommentVNode("v-if", true)
    ], 64 /* STABLE_FRAGMENT */));
}
